import { useParams } from "@reach/router";
import { useState, useRef, useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { useDesigns } from "../../hooks/useDesigns";
import { useProject } from "../../hooks/useProject";
import { useTeam } from "../../hooks/useTeam";
import { sumNumbers } from "./Projects";
import { useReducer } from "react";
import { v4 } from "uuid";
import { api } from "../../util/api";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import { TextFieldTWSolo } from "../../comp/tw/TextField";
import { ButtonTW } from "../../comp/tw/Button";
import SaveIcon from "@mui/icons-material/Save";
import { enqueueSnackbar } from "notistack";

const Quote = ({ costPerFt, pricePerFtBeforeTax }) => {
  const { projectId } = useParams();
  const { designs, isLoading, error } = useDesigns();
  const {
    project,
    isLoading: projectIsLoading,
    error: projectError,
    mutate,
  } = useProject(projectId);
  const { teamIsLoading, team, error: errorLoading } = useTeam();
  // const [removal, setRemoval] = useState(false);
  const timeoutRef = useRef(null);

  if (isLoading || projectIsLoading || teamIsLoading) {
    return <div className="spinner" />;
  }

  if (error || projectError || errorLoading) {
    return (
      <p>
        Error! please refresh the page, if the problem persists contact
        fencewizapp@gmail.com
      </p>
    );
  }
  const design = designs.find((design) => design.id === project.designId);

  const lengths = sumNumbers(Object.values(project.lengths));

  // let removalCost = 0;
  // if (removal) {
  //   removalCost = team.team.removalCostPerFt * lengths;
  // }

  // console.log(extrasCost);

  // console.log(subtotal);

  return (
    <>
      <div className="my-4">
        <TextFieldTWSolo
          type="number"
          value={project.adjustCost}
          label="Cost Adjustment Per Ft"
          onChange={(e) => {
            mutate(
              { ...project, adjustCost: e.target.value },
              {
                optimisticData: { ...project, adjustCost: e.target.value },
                revalidate: false,
              },
            );

            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
              api("PUT", `/project/${projectId}`, {
                adjustCost: e.target.value,
              });
              // mutate();
              // Perform other actions here, like making API calls or updating state
            }, 500);

            // }, 2);
            // dispatch({
            //   type: "updateItem",
            //   payload: { id: extra.id, item: e.target.value },
            // });
          }}
        />
      </div>
      <Extras />

      <A4Estimate
        key={`${projectId}-estimate`}
        project={project}
        clientName={`${project.clientFirstName} ${project.clientLastName}`}
        address={project.address}
        city={project.city}
        state={project.state}
        notes={project.notes}
        lineItems={[
          {
            item: design.name,
            ft: `${lengths}ft`,
            quantity: lengths,
            price: pricePerFtBeforeTax,
          },
          ...(project?.extras ? project.extras : []),
        ]}
        team={team}
        design={design}
        pricePerFtBeforeTax={pricePerFtBeforeTax}
        lengths={lengths}
      />

      {/* <Card>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <img src={team.team.logo} style={{ width: "35%" }} />
            <h3>{team.team.website}</h3>
          </div>
          <div>
            <h3>Estimate:</h3>
            <p>{new Date().toDateString()}</p>
            <h5>Prepared For:</h5>
            <div>
              <p>
                {project.clientFirstName} {project.clientLastName}
              </p>
              <p>{project.clientPhone}</p>
              <p>{project.address}</p>
              <p>{project.city}</p>
            </div>
            <div>
              <img
                src={design.image}
                style={{ width: "100%", maxWidth: "400px" }}
              />
            </div>
            <Grid container>
              <Grid item xs={12}>
                <p>{design.name} </p>
              </Grid>
              <Grid item xs={6}>
                <p>
                  ${pricePerFtBeforeTax} x {lengths}ft
                </p>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <p>${totalCost.toFixed(2)}</p>
              </Grid>
            </Grid>

            {project.extras?.length
              ? project.extras.map((extra, key) => {
                  return (
                    <Grid key={`${key}-extras`} container>
                      <Grid item xs={12}>
                        <p>{extra.item} </p>
                      </Grid>
                      <Grid item xs={6}>
                        <p>
                          ${extra.price} x {extra.quantity}
                        </p>
                      </Grid>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={2}>
                        <p>${(extra.price * extra.quantity).toFixed(2)}</p>
                      </Grid>
                    </Grid>
                  );
                })
              : null}

            {removal ? (
              <Grid container>
                <Grid item xs={12}>
                  <p>Removal and Disposal </p>
                </Grid>
                <Grid item xs={6}>
                  <p>
                    ${team.team.removalCostPerFt} x {lengths}ft
                  </p>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}>
                  <p>${removalCost.toFixed(2)}</p>
                </Grid>
              </Grid>
            ) : null}

            <Grid container>
              <Grid item xs={3}></Grid>

              <Grid item xs={3}>
                <p>Subtotal: </p>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <p>${subtotal.toFixed(2)}</p>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={3}></Grid>

              <Grid item xs={3}>
                <p>
                  {team.team.stateTax}% {team.team.state} Tax:
                </p>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <p>${tax.toFixed(2)}</p>
              </Grid>
            </Grid>
          </div>
        </div>
      </Card> */}
    </>
  );
};

export const A4Estimate = ({
  project,
  clientName,
  address,
  city,
  state,
  notes,
  lineItems,
  // extras,
  // length,
  // subtotal,
  // tax,
  team,
  design,
  pricePerFtBeforeTax,
  // lengths,
}) => {
  const [imageData, setImageData] = useState(null);
  const [designImage, setDesignImage] = useState(null);

  useEffect(() => {
    const fetchImage = async (url, set) => {
      try {
        const response = await fetch(url, {
          mode: "cors",
          credentials: "omit",
        });

        if (!response.ok) {
          console.warn(`Failed to fetch image: ${response.status}`);
          // Fall back to using the URL directly
          set(url);
          return;
        }

        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          const base64String = reader.result;
          set(base64String);
        };

        reader.onerror = () => {
          console.warn("FileReader error, falling back to URL");
          set(url);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.warn("Error fetching image, falling back to URL:", error);
        // Fall back to using the URL directly
        set(url);
      }
    };

    if (team.team.logo) {
      fetchImage(team.team.logo, setImageData);
    }

    if (design.image) {
      fetchImage(design.image, setDesignImage);
    }
  }, [team.team.logo, design.image]);

  const pdfRef = useRef();

  const generatePDF = () => {
    enqueueSnackbar("Downloading...");

    const input = pdfRef.current;

    html2canvas(input, {
      scale: 1.5, // Reduced from 2 for smaller file size
      useCORS: true, // Enable cross-origin images
      logging: false, // Reduce console noise
      allowTaint: false, // Don't allow tainted canvas
      backgroundColor: "#ffffff",
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.75); // Use JPEG with 75% quality instead of PNG
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true, // Enable PDF compression
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgRatio = canvas.width / canvas.height;
      let imgWidth, imgHeight;

      if (imgRatio > pageWidth / pageHeight) {
        // Image is wider than the page, adjust width
        imgWidth = pageWidth;
        imgHeight = imgWidth / imgRatio;
      } else {
        // Image is taller than the page, adjust height
        imgHeight = pageHeight;
        imgWidth = imgHeight * imgRatio;
      }

      const x = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;
      const y = (pdf.internal.pageSize.getHeight() - imgHeight) / 2;

      pdf.addImage(imgData, "JPEG", x, y, imgWidth, imgHeight);
      pdf.save(`${clientName} Estimate.pdf`);

      enqueueSnackbar("Downloaded...", { variant: "success" });
    });
  };

  // const totalCost =
  //   sumNumbers(Object.values(project.lengths)) * pricePerFtBeforeTax;
  // const lengths = sumNumbers(Object.values(project.lengths));

  // let removalCost = 0;
  // if (removal) {
  //   removalCost = team.team.removalCostPerFt * lengths;
  // }

  const subtotal = sumNumbers(
    lineItems.map((item) => parseFloat(item.price) * parseFloat(item.quantity)),
  );
  // console.log(subtotal);
  const tax = subtotal * ((team?.team?.serviceTax || 0) / 100 + 1) - subtotal;

  // console.log(project);
  return (
    <>
      <ButtonTW onClick={generatePDF} label={"Download as PDF"} />

      <div
        ref={pdfRef}
        className="bg-white p-5 md:p-10 mx-auto my-10 border border-gray-300 shadow-md max-w-[210mm] max-h-[600mm] text-gray-800"
      >
        {/* Header */}
        <header className="mb-10">
          <div className="flex justify-between items-center">
            <h1 className="text-3xl font-bold">Quote</h1>
            {imageData && <img src={imageData} alt="logo" className="w-24" />}
          </div>

          <p className="text-lg">{team?.team?.name}</p>
          {clientName ? (
            <p className="text-sm">Prepared For: {clientName}</p>
          ) : null}

          <p className="text-sm">{address}</p>
          {city && state ? (
            <p className="text-sm">
              {city}, {state}
            </p>
          ) : null}

          <p className="text-sm">Date: {new Date().toDateString()}</p>
        </header>

        {/* Project Details */}
        {notes && (
          <section className="mb-10">
            <h2 className="text-xl font-semibold mb-2">Project Details</h2>
            <p style={{ whiteSpace: "pre-wrap" }}>{notes}</p>
          </section>
        )}

        {designImage ? (
          <img src={designImage} className="h-60" alt="designImage" />
        ) : null}

        {/* Line Items Table */}
        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-2">Line Items</h2>
          <div className="grid grid-cols-5 text-sm">
            <p className="border-y-4 p-2 text-left col-span-2">Item</p>
            <p className="border-y-4 p-2 text-left">Quantity</p>
            <p className="border-y-4 p-2 text-left">Price</p>
            <p className="border-y-4 p-2 text-right">Total</p>

            {lineItems &&
              lineItems.map((item, idx) => (
                <div key={`${idx}-line-item`} className="contents">
                  <p className="p-2 col-span-2">{item.item}</p>
                  <p className="p-2">{item.ft ? item.ft : item.quantity}</p>
                  <p className="p-2 text-left">
                    ${parseFloat(item.price).toFixed(2)}
                  </p>
                  <p className="p-2 text-right">
                    $
                    {(
                      parseFloat(item.price) * parseFloat(item.quantity)
                    ).toFixed(2)}
                  </p>
                </div>
              ))}
          </div>
        </section>

        {/* Totals */}
        <section className="mt-10">
          <div className="flex justify-between font-semibold text-lg">
            <span>Subtotal:</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span>Tax:</span>
            <span>${tax.toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-bold text-xl mt-4">
            <span>Total:</span>
            <span>${(subtotal + tax).toFixed(2)}</span>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-20 text-sm text-gray-600">
          <p>Thank you for your business!</p>
          <p>Please contact us with any questions regarding this estimate.</p>
        </footer>
      </div>
    </>
  );
};

// const initState = [{ id: "1", item: "", price: "", quantity: "" }];

function reducer(state, action) {
  if (action.type === "addBlank") {
    return [...state, { id: v4(), item: "", price: "", quantity: "" }];
  }
  if (action.type === "removeItem") {
    console.log(state[0].id, action.payload);
    return state.filter((item) => item.id !== action.payload);
  }

  if (action.type === "updateItem") {
    return state.map((item) => {
      if (item.id === action.payload.id) {
        return { ...item, ...action.payload };
      }
      return item;
    });
  }
}

export const Extras = ({ where = null }) => {
  const { projectId } = useParams();

  const {
    project,
    isLoading: projectIsLoading,
    error: projectError,
    mutate,
  } = useProject(projectId);

  const getInitialExtras = () => {
    if (where === null) {
      return project?.extras || [];
    }
    return project?.splits?.[where]?.extras || [];
  };

  const [extras, dispatch] = useReducer(reducer, getInitialExtras());

  if (projectIsLoading) {
    return <div className="spinner" />;
  }

  if (projectError) {
    return (
      <p>
        Error! please refresh the page, if the problem persists contact
        fencewizapp@gmail.com
      </p>
    );
  }

  const saveRow = () => {
    const payload =
      where === null
        ? { extras }
        : {
            splits: {
              ...project.splits,
              [where]: {
                ...(project.splits?.[where] || {}),
                extras,
              },
            },
          };

    const optimisticData =
      where === null
        ? { ...project, extras }
        : {
            ...project,
            splits: {
              ...project.splits,
              [where]: {
                ...(project.splits?.[where] || {}),
                extras,
              },
            },
          };

    mutate(api("PUT", `/project/${projectId}`, payload), { optimisticData });
    enqueueSnackbar("Line Items Updated", { variant: "success" });
  };

  return (
    <div>
      {extras.map((e, idx) => (
        <QuoteRow
          key={`${idx}-extras`}
          extra={e}
          dispatch={dispatch}
          project={project}
          mutate={mutate}
        />
      ))}
      <div>
        <ButtonTW
          variant="primary"
          label={<PlaylistAddIcon />}
          onClick={() => dispatch({ type: "addBlank" })}
          className="w-24"
        />
        <ButtonTW
          variant="secondary"
          className="ml-2 w-24"
          label={<SaveIcon />}
          onClick={saveRow}
        />
      </div>
    </div>
  );
};

const QuoteRow = ({ extra, dispatch, mutate, project }) => {
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-10 my-2 items-center gap-4">
        <TextFieldTWSolo
          value={extra.item}
          label="Item"
          onChange={(e) => {
            dispatch({
              type: "updateItem",
              payload: { id: extra.id, item: e.target.value },
            });
          }}
          className="md:col-span-3"
        />
        <TextFieldTWSolo
          value={extra.price}
          label="Price ($)"
          onChange={(e) => {
            dispatch({
              type: "updateItem",
              payload: { id: extra.id, price: e.target.value },
            });
          }}
          className="md:col-span-3"
        />
        <TextFieldTWSolo
          value={extra.quantity}
          label="Quantity"
          onChange={(e) => {
            dispatch({
              type: "updateItem",
              payload: { id: extra.id, quantity: e.target.value },
            });
          }}
          className="md:col-span-3"
        />
        <ButtonTW
          label={<PlaylistRemoveIcon />}
          variant="danger"
          // size="small"
          onClick={() => {
            // api("PUT")
            console.log(extra.id);
            dispatch({ type: "removeItem", payload: extra.id });
          }}
          className="md:col-span-1"
        />
      </div>
    </div>
  );
};

export default Quote;
